import { ApiError } from '@platform/api-client';
import { errorMessageKey, useTranslation } from '@platform/i18n';

export type ApiErrorMessage = { readonly message: string; readonly code: string | null };

export const useApiErrorMessage = (): ((error: unknown) => ApiErrorMessage | null) => {
  const { t } = useTranslation();
  return (error: unknown) => {
    if (error === null || error === undefined) return null;
    const code = error instanceof ApiError ? error.code : null;
    return { message: t(errorMessageKey(code ?? undefined)), code };
  };
};
